import { render, staticRenderFns } from "./SessionApi.vue?vue&type=template&id=22285916"
import script from "./SessionApi.vue?vue&type=script&lang=js"
export * from "./SessionApi.vue?vue&type=script&lang=js"
import style0 from "./SessionApi.vue?vue&type=style&index=0&id=22285916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports